// export const BASE_URL = 'https://dev-dg-env.azerconnect.az/mno-product/api/v1';
export const BASE_URL = 'https://esim.bakcell.com/api';

// Gateway path of the ICCID ↔ organization batch endpoints.
export const ICCID_ORGANIZATION_PATH = '/iccid-assignment/api/v1/iccid/organization';

export const DOCUMENT_SERIES = {
  AZE: 3,
  AA: 2,
  AB: 2,
};

export const PROVIDER_ID = [
  { value: 1, label: 'Azerfon' },
  { value: 2, label: 'Bakcell' },
];

export const USER_TYPE = [
  { value: 'CORPORATE', label: 'Corporate' },
  { value: 'INDIVIDUAL', label: 'Individual' },
  { value: 'GOVERNMENT', label: 'Government' },
];

export const DEFAULT_SUPPLEMENTARY_FORM = {
  offerId: '',
  title: '',
  nameAz: '',
  nameEng: '',
  nameRu: '',
  price: '',
  providerId: '',
  primaryOfferIds: [],
  esimFlag: false,
  dataSimFlag: false,
  asanImzaFlag: false,
  userType: '',
};